var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.666626,
    width: 16.6667,
    height: 16.6667,
    fill: "url(#pattern0_1054_12487)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1054_12487",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1054_12487",
    transform: "scale(0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1054_12487",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAACZUlEQVR4nO1WTWsUQRDtXW+e9GYUN9u1yd2oKCw7VUMiCmrwlL/g1avETL+DBETxIOQP6CkJHs0xGhT0F4hGRQ+K6PpxiF5MBKVmu7PjwjqzyaggedCXmpp6U69fV48xO+iHqaldteiSrcfJcWLcsuLeW8ZHEiyS4OjBJvabslGPcNIyXpDgx++WFTwjxulSSG2EY1awnhZm91o/wIpbGhbUa9H0EIlbsIK2KuBzNuoReFukJGiRuNVON+6GMaj2z0aV2F3rdO9WR3hmbEuk9Tg5RYzvXsK1Wuvi3rx3ho5gt+b6d9YpwvjAxMTuSUc6XNWCId6Ik3PEWCHGV12W3T3LyWR4PizYQ4K50PlApLV079KvbmfltYIr/c3lZrsVUCXBW42rFwoTNyIc9kb58Eun+a4+m1Hslca0VmFiYtz2heaNMRUfWylAfDdT44435c3ixILPXqZ9IWbZfSlAvBbyVeI0znhXmDicyez+DEo8Oj59oHe7cqEj0cu0FGLq3nxit+zTK7pN3nQL+Yw95lKDdImTyTxiipMzm/mC9sDmGm2B/Bl+E8yVKiFutm+37C53K6AaiLM+KYKKZffcF53ToRAe6JFR9+qep0vccrZTHTYk7rqX/rEZFBQnEzrwg2my06sfdKxujkx2G1ZwwmwFIzwzFi4JvQByL4kwKhlPGxGaZjtoRGhmOm/7Na8Xvx43dT4JXqofvLzfhgWHTBmgOJnIdbRfDUFcCmlAUWJTNmiHWP6B1FZdzu5Cg3E+/Aj+BWL3SV2eibfCbfZniNk9IHaPdI73PtOYFTwkwf3Sic3/gp/1NAp9s98ougAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.885e997d9ad4d7556162a055516f2667.svg";
export { ForwardRef as ReactComponent };